if (!customElements.get('ft-catalog-sizes')) {
  customElements.define('ft-catalog-sizes', class extends HTMLElement {
    connectedCallback() {
      this.grid = document.getElementById(this.dataset.grid);
      this.select = this.querySelector('select');
      this.count = this.querySelector('[data-size-count]');
      if (!this.grid || !this.select || !this.count) return;
      const selected = new URL(window.location.href).searchParams.get('ft_size') || '';
      this.select.value = [...this.select.options].some(option => option.value === selected) ? selected : '';
      this.onChange = () => {
        const url = new URL(window.location.href);
        if (this.select.value) url.searchParams.set('ft_size', this.select.value);
        else url.searchParams.delete('ft_size');
        window.history.replaceState({}, '', url);
        this.filter();
      };
      this.select.addEventListener('change', this.onChange);
      this.onPopState = () => {
        this.select.value = new URL(window.location.href).searchParams.get('ft_size') || '';
        this.filter();
      };
      window.addEventListener('popstate', this.onPopState);
      this.hidden = false;
      this.filter();
    }
    filter() {
      const size = this.select.value;
      let count = 0;
      this.grid.querySelectorAll('[data-ft-sizes]').forEach(card => {
        const matches = !size || card.dataset.ftSizes.includes(`|${size}|`);
        card.hidden = !matches;
        if (matches) count += 1;
      });
      const label = count ? this.dataset.countLabel : this.dataset.emptyLabel;
      this.count.textContent = size ? label.replace('[count]', String(count)).replace('[size]', size) : '';
    }
    disconnectedCallback() {
      this.select?.removeEventListener('change', this.onChange);
      window.removeEventListener('popstate', this.onPopState);
    }
  });
}
